import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

export default function EditButton({ disabled = false, handleOnClick = () => {} }) {
  return (
    <div
      className="p-5"
      style={{
        height: 32,
        width: 32,
        borderRadius: "50%",
        backgroundColor: disabled ? HNSColors.neutrals[800] : HNSColors.secondary[500],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={handleOnClick}
    >
      <CustomIconButton
        iconVisible
        disabled={disabled}
        CustomIcon={
          <Svg
            name={SvgEnum.HisEdit3}
            color={disabled ? HNSColors.neutrals[500] : HNSColors.neutrals[900]}
            sx={{ height: 20, width: 20 }}
          />
        }
      />
    </div>
  );
}
